import * as basicLightbox from "basiclightbox";
import { default as YTPlayer } from "youtube-player";
import { YouTubePlayer } from "youtube-player/dist/types";
import WindowSize from "./WindowSize";

class YouTube {
    player: YouTubePlayer | null;
    triggers: string;

    constructor() {
        this.player = null;
        this.triggers = "[data-youtube]";
        const triggerNodes: NodeListOf<Element> = document.querySelectorAll(
            this.triggers,
        );
        this.addEvents(triggerNodes);
    }

    /**
     * Trigger video click
     * @param triggerNodes
     */
    addEvents(triggerNodes: NodeListOf<Element>) {
        [...Array.from(triggerNodes)].forEach((el) => {
            el.addEventListener("click", (e) => {
                const target: HTMLElement = e.currentTarget as HTMLElement;
                const id = target?.getAttribute("data-youtube");
                if (id != null) this.play(id);
            });
        });
    }

    /**
     * Play video in lightbox
     * @param id
     */
    play(id: string) {
        basicLightbox.create('<div id="player"></div>').show();
        this.player = YTPlayer("player", getSize());
        this.player.loadVideoById(id);
        this.player.playVideo();
    }
}

export default YouTube;

/**
 * Get size for video
 * @returns {*}
 */
const getSize = () => {
    if (WindowSize.isMobile()) {
        return {
            height: "360",
            width: "640",
        };
    }
    return {
        height: "480",
        width: "854",
    };
};
